import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import logo_color from "../../common/media/cc_logo_color.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../../common/components/Projects/ProjectsList";
import { projects as getProjects } from '../../common/api/projects'
import {trackAdditionalPageView} from "../../common/util/ccAnalyticsV2";

const BusinessPage = ({ merchantCode, fetchedImpact }) => {

    const [selectedPlan, setSelectedPlan] = useState({});
    const [projects, setProjects] = useState();
    useEffect(() => {
        getProjects("AU")
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);
        //trackAdditionalPageView('TON_OF_FUN_AU-landing-page');


        console.log('run widget')
        const script = document.createElement('script');
        script.src = `${process.env.BUSINESS_CALCULATOR_BASE_URL}/carbonclick-embed.latest.js`;
        script.addEventListener('load', () => {
            console.log('attach widget')
            window.carbonClickEmbed(document.querySelector('#CalculatorWidgetMount:empty'));
            console.log('widget success')
        });
        script.async = true;
        document.body.appendChild(script);



    }, []);
    const planChosen = () => {
        history.push("subscribe/payment");
    };
    return (
        <div>
            <div className="" >
                <div className="px-3">
                    <img className="mw-100 center" src="https://res.cloudinary.com/carbonclick/image/upload/v1618807530/Enterprise/Ton%20Of%20Fun/tonoffun-hero_bbmfch.png" />
                </div>
            </div>

            <div id="content" className="py-6">
                <div className="container text-center">
                    <div className="mb-3 center mw-600px">
                        <img className="center mb-3" style={{ height: '210px' }} src="https://res.cloudinary.com/carbonclick/image/upload/v1619048781/Enterprise/Ton%20Of%20Fun/ATOF-icon_yhnh7t.png" />
                        <h3 className="font-bold">Take action and make your small business climate friendly today</h3>
                        <h5>The climate action portal helps you effortlessly reduce the environmental impact of your business, with our simple calculator, relevant educational content and ability to buy gold standard carbon offsets from projects that make a real traceable difference. </h5>
                    </div>

                    <div className="row">
                        <div className="col-4">

                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                                <path d="M21.0625 49.5V45.125H29.8125V49.5H21.0625ZM34.1875 49.5H42.9375V45.125H34.1875V49.5ZM56.0625 32V36.375V45.125H51.6875V36.375H47.3125V45.125H42.9375V40.75H21.0625V45.125H16.6875V36.375H12.3125V45.125H7.9375V36.375V32H12.3125V27.625H16.6875V23.25H21.0625V18.875H25.4375V23.25H38.5625V18.875H42.9375V23.25H47.3125V27.625H51.6875V32H56.0625ZM25.4375 27.625H21.0625V32H25.4375V27.625ZM42.9375 27.625H38.5625V32H42.9375V27.625ZM47.3125 14.5H42.9375V18.875H47.3125V14.5ZM16.6875 14.5V18.875H21.0625V14.5H16.6875Z" fill="black" />
                            </svg>
                            <h4 className="color-primary font-bold">Reason 1</h4>
                            <p>Measure and track the positive impact your small business is having on the environment.</p>

                        </div>
                        <div className="col-4">

                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                                <path d="M32 5.75C17.5021 5.75 5.75 17.5021 5.75 32C5.75 46.4979 17.5021 58.25 32 58.25C46.4979 58.25 58.25 46.4979 58.25 32C58.25 17.5021 46.4979 5.75 32 5.75ZM32 54.9688C19.3146 54.9688 9.03125 44.6854 9.03125 32C9.03125 19.3146 19.3146 9.03125 32 9.03125C44.6854 9.03125 54.9688 19.3146 54.9688 32C54.9688 44.6854 44.6854 54.9688 32 54.9688ZM32 12.3125C21.1271 12.3125 12.3125 21.1271 12.3125 32C12.3125 42.8729 21.1271 51.6875 32 51.6875C42.8729 51.6875 51.6875 42.8729 51.6875 32C51.6875 21.1271 42.8729 12.3125 32 12.3125ZM21.393 25.7612L18.1572 23.1911C18.8921 22.0385 19.7685 20.9836 20.7606 20.0504L23.3241 23.2746C22.5798 24.0153 21.9294 24.8507 21.393 25.7612ZM23.7551 17.8135C25.5733 16.7549 27.6136 16.0361 29.7889 15.7428L30.2769 19.8159C28.585 20.0531 27.0023 20.6334 25.6046 21.4859L23.7551 17.8135ZM32 35.2812C30.1875 35.2812 28.7188 33.8125 28.7188 32C28.7188 30.1875 30.1875 28.7188 32 28.7188C33.8125 28.7188 35.2812 30.1875 35.2812 32C35.2812 33.8125 33.8125 35.2812 32 35.2812ZM38.3954 21.486C36.9977 20.6334 35.4151 20.0532 33.7233 19.816L34.2111 15.7429C36.3864 16.0363 38.4268 16.755 40.2449 17.8136L38.3954 21.486ZM42.6071 25.7612C42.0706 24.8507 41.4202 24.0153 40.676 23.2746L43.2395 20.0504C44.2316 20.9836 45.1079 22.0385 45.8428 23.1911L42.6071 25.7612Z" fill="black" />
                            </svg>
                            <h4 className="color-primary font-bold">Reason 2</h4>
                            <p>Promote your climate action among your team and to your customers.</p>

                        </div>
                        <div className="col-4">

                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                                <path d="M4 31.925C4 40.075 10.1875 46 17.8375 46H46.1625C53.8125 46 60 40.075 60 31.925C60 23.775 53.8125 18 46.1625 18H17.8375C10.1875 18 4 23.7875 4 31.925ZM50.6 29.1625C51.9375 29.1625 53.025 30.225 53.025 31.5375C53.025 32.85 51.9375 33.9125 50.6 33.9125C49.2625 33.9125 48.175 32.85 48.175 31.5375C48.175 30.225 49.2625 29.1625 50.6 29.1625ZM45.2875 23.975C46.6375 23.975 47.725 25.0375 47.725 26.35C47.725 27.6625 46.6375 28.725 45.2875 28.725C43.95 28.725 42.8625 27.6625 42.8625 26.35C42.8625 25.0375 43.95 23.975 45.2875 23.975ZM45.2875 34.3625C46.6375 34.3625 47.725 35.4125 47.725 36.7375C47.725 38.05 46.6375 39.1 45.2875 39.1C43.95 39.1 42.8625 38.0375 42.8625 36.7375C42.875 35.4125 43.95 34.3625 45.2875 34.3625ZM39.975 29.1625C41.325 29.1625 42.4125 30.225 42.4125 31.5375C42.4125 32.85 41.325 33.9125 39.975 33.9125C38.6375 33.9125 37.55 32.85 37.55 31.5375C37.55 30.225 38.6375 29.1625 39.975 29.1625ZM11 30.6625C11 30.325 11.225 30 11.5375 30H11.675H16V25.225V25.15C16 24.8 16.2625 24.5 16.6 24.5H19.3375C19.675 24.5 20.0125 24.8 20.0125 25.15V25.2125V30H24.6625H24.7375C25.075 30 25.3875 30.3125 25.3875 30.6625V33.375C25.3875 33.7375 25.075 34 24.7375 34H24.675H20V38.825V38.8875C20 39.2375 19.6625 39.5 19.325 39.5H16.5875C16.2625 39.5 15.9875 39.2625 15.9875 38.9375V38.8V34H11.6375H11.575C11.2375 34 11 33.7375 11 33.375V30.6625Z" fill="black" />
                            </svg>

                            <h4 className="color-primary font-bold">Reason 3</h4>
                            <p>Take a climate leadership role and offset your team’s personal carbon footprints.</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-secondary position-relative py-5 img-contain" id="FlightCalculator" style={{ backgroundRepeat: "no-repeat", backgroundPosition: "left" }}>
                <div className="container mobile-p-0 position-relative z-2">
                    <div className="center py-4">
                        <div id="CalculatorWidgetMount" data-carbonclick-embed="calculator-widget" data-carbonclick-merchant-referrer-code="TON_OF_FUN_AU"></div>
                    </div>
                </div>

                <div className="position-absolute w-100 bottom-abs">
                    <img className="w-100" src="https://res.cloudinary.com/carbonclick/image/upload/v1619140443/Enterprise/Ton%20Of%20Fun/tof-bg_e7lxuo.png" />
                </div>
            </div>

            <div className="container py-5">
                <div className="bg-primary p-4 text-center">
                    <div className="center mw-720px">
                        <div className="mb-3">
                        <h3 className="font-bold">Want to gain customers as you<br/>help save the planet?</h3>
                                <h5 className="mb-3">Encouraging your customers to play a positive role in the battle against global emissions isn’t as hard as it seems. Allow them to make a difference to the planet by equipping your checkout with carbon offset purchases and a climate-friendly cart. Help them become a part of a critical movement that’s more important than ever before.</h5>
                            <a href="https://www.carbonclick.com/climate_friendly_cart/" target="_blank" className="btn btn-secondary">GET THE CLIMATE FRIENDLY CART</a>
                        </div>

                        <div className="d-flex" style={{ justifyContent: 'center' }}>
                            <h6 className="font-bold mr-2 mt-1">Powered By</h6>
                            <div>
                             <img style={{ height: 30 }} src={logo_color} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {Array.isArray(projects) && <>
                <div className="py-6">
                    <div className="container text-center">
                        <div className="mb-5 center mw-600px">
                            <h3 className="font-bold">Support Projects That Fight<br />Climate Change</h3>
                            <p>A Ton of Fun’s small business offsets are powered by CarbonClick which supports only the highest quality carbon offsetting projects around the world, to bring you peace of mind and results.</p>
                        </div>
                        <div className="text-left mobile-text-center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            </>}

            <div className="py-6 mobile-p-0">
                <div className="container text-center">
                    <h3 className="font-bold mb-4">Ton of Fun FAQs</h3>
                    <div className="mb-3 center text-left mw-800px">
                        <Accordian title={"What is a carbon offset?"} >A carbon credit is what is bought and sold when dealing with voluntary carbon offsets. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) or the Emissions Trading Register (New Zealand).</Accordian>
                        <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                        <Accordian title={"How do I know the offset is trustworthy?"} >CarbonClick is committed to making carbon offsetting safe and trustworthy, we do this by tracing every transaction to the projects it supported so you can see the retirement certificates for every kg of CO2 offset. The trace link is sent in every purchase confirmation email, and can also be found on our website.</Accordian>
                    </div>
                    <div className="mobile-show py-5"></div>
                </div>
            </div>

            <img className="w-100 center" src="https://res.cloudinary.com/carbonclick/image/upload/v1618807528/Enterprise/Ton%20Of%20Fun/TonofFunFooter_dh6tzz.png" />

            <div className="w-100 img-cover footer-img py-6 bg-tertiary" >
                <div className="container color-white py-5">
                    <p><b>A Ton of Fun Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://cc-prod-mail-assets.s3-ap-southeast-2.amazonaws.com/Privacy+Policy.pdf"} target="_blank" rel="noopener noreferrer">CarbonClick's Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://cc-prod-mail-assets.s3-ap-southeast-2.amazonaws.com/Terms+of+Service.pdf"} target="_blank" rel="noopener noreferrer">CarbonClick's Terms &amp; Conditions</a></div>

                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default BusinessPage;